<template>
    <div class="p20">
        <h3 class="text-center">计费规则</h3>
        <div class="text-left pt10">
            <p class="pb10">
                 {{ cabinetInfo  && cabinetInfo.chargeMoney }}元 / {{
                  cabinetInfo && cabinetInfo.chargeType === "HOUR"
                    ? (cabinetInfo && parseInt(cabinetInfo.capaUnit)> 1 ? cabinetInfo.capaUnit:'') + "小时"
                    : cabinetInfo && cabinetInfo.chargeType === "DAY"
                    ? (cabinetInfo  && parseInt(cabinetInfo.capaUnit)> 1 ? cabinetInfo.capaUnit:'') + "天"
                    : (cabinetInfo  && parseInt(cabinetInfo.capaUnit)> 1 ? cabinetInfo.capaUnit:'') + "分钟"
                }}
                <span style="color:red;">租借{{ cabinetInfo ? cabinetInfo.freeTime:'' }}分钟内免费</span>，日封顶{{
                  cabinetInfo 
                    ? cabinetInfo.dayMoneyMax
                    : 0
                }}元，总封顶{{
                  cabinetInfo  ? cabinetInfo.depositMoney : 0
                }}元，{{
                  cabinetInfo &&cabinetInfo.freeTimeFlag==1 ? '计费时间不含免费时间' : '计费时间含免费时间'
                }}            </p>
            <p class="pb10">
                归还轮椅时，请确保账号余额充足，如因余额不足无法及时代扣费用，可能会影响您的信用分数。
            </p>
        </div>
    </div>
</template>

<script>
    import cabinetServ from '../service/cabinetServ'
    import mintUi from '../lib/mint-ui'
    export default {
        data () {
            return {
                headPhoto: '/static/images/touxiang@2x.png',
                userName: '',
                isLoading: false,
                isNormal: null,
                cabinetInfo: null,
                number: null,
                qrCode: null,
                hasMore: false,
                isBackBed: null,
                list: null,
                wxId: null,
                giveBackList: null,
                alipayWap: null,
                isDisabled: false,
                bannerList: [],
                timerList:[],
                isFree: null,
                isMz: null
            }
        },
        created () {
            let qrCode = this.$route.query.qrcode
            console.log('qrCode:'+this.$route.query.qrcode)
            this.qrCode = qrCode
            this.getCabinetSta(qrCode)
        },
        methods: {
            // 获取设备状态
            getCabinetSta (qrCode){
                this.isLoading = true
                cabinetServ.getCabinetStatus(qrCode).then(res =>{
                    this.isLoading = false
                    if(res.code === '200'){
                        if(!res.data){

                        } else {
                            this.cabinetInfo = res.data.cabinet
                        }
                    } else {
                        mintUi.Toast({
                            message: res.message,
                            position: 'bottom'
                        })
                    }
                })
            },
        },
        mounted () {

        }
    }
</script>

<style lang="less" scoped>
    @import '../less/_var.less';
    @import '../less/index.less';
</style>


// WEBPACK FOOTER //
// src/pages/expenses.vue